module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAG5JREFUWEft1UEKACEQA8HJ/x89fkBBaQ8ivWcjoQxs6vEvj/crC9IXUlBBKkDzblBBKkDzblBBKkDzyw12d9PLT/JJpl0suKuo4K7U6tx/glTkVt5fHZVUUEEqQPNuUEEqQPNuUEEqQPNu8HvBAS1YGCmpBbSnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_time_line_2_cancel.png
// module id = hPs1
// module chunks = 1